// src/api.js
const API_BASE = 'https://te-ayudo.es/back/api';


function toQS(params) {
  const p = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.set(k, String(v));
  });
  return p.toString();
}

// ---------- Auth ----------
export async function login(email, password) {
  const res = await fetch(`${API_BASE}/login.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || 'Error de login');
  return data;
}

export async function me() {
  const res = await fetch(`${API_BASE}/me.php`, { credentials: 'include' });
  return res.json();
}

export async function logout() {
  const res = await fetch(`${API_BASE}/logout.php`, {
    method: 'POST',
    credentials: 'include'
  });
  return res.json();
}

// ---------- Pacientes ----------
export async function crearPaciente(payload) {
  const res = await fetch(`${API_BASE}/patients.create.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || 'Error al crear paciente');
  return data;
}

export async function listarPacientes({
  q = "",
  page = 1,
  page_size = 10,
  specialty_codes = [],
  specialty_ids = [],
  with_counts = 0,
} = {}) {
  const params = new URLSearchParams();

  if (q) params.set("q", q);
  params.set("page", String(page));
  params.set("page_size", String(page_size));

  // ✅ backend soporta CSV
  if (Array.isArray(specialty_codes) && specialty_codes.length) {
    params.set("specialty_codes", specialty_codes.join(","));
  }

  if (Array.isArray(specialty_ids) && specialty_ids.length) {
    params.set("specialty_ids", specialty_ids.join(","));
  }

  if (with_counts) params.set("with_counts", "1");

  const url = `${API_BASE}/patients.list.php?${params.toString()}`;
  console.log("➡️ listarPacientes URL:", url); // ✅ déjalo para comprobar

  const res = await fetch(url, { credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || "Error al listar pacientes");
  return data;
}

export async function actualizarPaciente(id, payload) {
  const res = await fetch(`${API_BASE}/patients.update.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ id, ...payload }),
  });

  const text = await res.text();

  if (!res.ok) {
    console.error("[actualizarPaciente] HTTP", res.status, res.statusText, "RAW:", text);
    throw new Error(`Error al actualizar paciente (${res.status})`);
  }

  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    console.error("[actualizarPaciente] NO JSON:", text);
    throw new Error("Respuesta inválida del servidor (no es JSON)");
  }

  if (data.ok === false) throw new Error(data.error || "Error al actualizar paciente");
  return data;
}


export async function actualizarCamposClinicosPaciente(id, payload) {
  const res = await fetch(`${API_BASE}/patients.update_campos_clinicos.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ id, ...payload }),
  });

  const contentType = res.headers.get("content-type") || "";
  let data = null;

  if (contentType.includes("application/json")) {
    data = await res.json().catch(() => ({}));
  } else {
    // probablemente nos han devuelto el HTML del login
    const text = await res.text();
    console.error(
      "[actualizarCamposClinicosPaciente] Respuesta NO JSON:",
      text.slice(0, 200)
    );
    throw new Error("El servidor devolvió una respuesta no válida (¿login?).");
  }

  console.log("[actualizarCamposClinicosPaciente] response JSON:", data);

  if (!res.ok || !data || data.ok !== true) {
    throw new Error(data?.error || "Error al actualizar campos clínicos del paciente");
  }

  return data;
}



export async function obtenerPaciente(id) {
  const res = await fetch(`${API_BASE}/patients.get.php?id=${id}`, {
    credentials: "include",
  });

  // 1) Leemos SIEMPRE como texto, para poder inspeccionarlo
  const text = await res.text();

  // 2) Si la respuesta HTTP no es OK, logueamos el texto (suele ser HTML o un error PHP)
  if (!res.ok) {
    console.error(
      "[obtenerPaciente] Error HTTP:",
      res.status,
      res.statusText,
      "Respuesta cruda:",
      text
    );
    throw new Error(`Error al obtener paciente (${res.status})`);
  }

  // 3) Intentamos parsear el texto como JSON
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch (e) {
    console.error(
      "[obtenerPaciente] La respuesta NO es JSON válido. Texto recibido:",
      text
    );
    throw new Error("Respuesta inválida del servidor al obtener paciente");
  }

  // 4) Validamos la estructura
  if (data.ok === false) {
    throw new Error(data.error || "Error al obtener paciente");
  }

  if (!data.patient) {
    console.error("[obtenerPaciente] JSON sin 'patient':", data);
    throw new Error("El servidor no ha devuelto datos de paciente");
  }

  return data.patient;
}


// ---------- Calendario / Sesiones ----------
export async function listarEventos({ calendar, start, end }) {
  const qs = toQS({ calendar, start, end });
  const res = await fetch(`${API_BASE}/events.list.php?${qs}`, { credentials: 'include' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || 'Error al listar eventos');
  return data.items || [];
}

export async function servicesDisponibles(patient_id, specialty) {
  const qs = toQS({ patient_id, specialty });
  const res = await fetch(`${API_BASE}/events.services.php?${qs}`, { credentials: 'include' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || 'Error al cargar servicios');
  return data; // {items:[{code,label,min}], hasPrev}
}

export async function disponibilidad({ specialty, date, duration }) {
  const qs = toQS({ specialty, date, duration });
  const res = await fetch(`${API_BASE}/events.availability.php?${qs}`, { credentials: 'include' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || 'Error al cargar disponibilidad');
  return data.slots || []; // [{start,end}]
}

export async function crearSesion(payload) {
  const res = await fetch(`${API_BASE}/sessions.create.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok || !data.ok) throw new Error(data.error || 'Error al crear sesión');
  return data;
}


export async function listarComentarios(patient_id) {
  const res = await fetch(`${API_BASE}/comments.list.php?patient_id=${patient_id}`, { credentials:'include' });
  const data = await res.json().catch(()=>({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || 'Error listando comentarios');
  return data.items || [];
}

export async function crearComentario(patient_id, body) {
  const res = await fetch(`${API_BASE}/comments.create.php`, {
    method: 'POST',
    headers: { 'Content-Type':'application/json' },
    credentials: 'include',
    body: JSON.stringify({ patient_id, body })
  });
  const data = await res.json().catch(()=>({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || 'Error creando comentario');
  return data;
}


export async function listarProgresoPaciente(id, { date } = {}) {
  const params = new URLSearchParams();
  if (date) params.set("date", date);

  const res = await fetch(`${API_BASE}/patient.progress.php?id=${id}&${params.toString()}`, {
    credentials:'include'
  });
  const data = await res.json().catch(()=>({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || 'Error al cargar progreso');
  return data.items;
}

// api.js
export async function listarSesiones({ specialty, date, patient_id } = {}) {
  const params = new URLSearchParams();
  if (specialty) params.set("specialty", specialty);
  if (date) params.set("date", date);
  if (patient_id) params.set("patient_id", patient_id); // 👈 AÑADIDO

  const res = await fetch(`${API_BASE}/sessions.list.php?${params.toString()}`, {
    credentials: "include",
  });
  const data = await res.json();
  if (!res.ok || !data.ok)
    throw new Error(data.error || "Error al listar sesiones");
  return data;
}


export async function eliminarPaciente(id) {
  const res = await fetch(`${API_BASE}/patients.delete.php?id=${id}`, {
    method: "DELETE",
    credentials: "include",
  });
  if (!res.ok) throw new Error("Error eliminando paciente");
  return res.json();
}

export async function eliminarSesion(id) {
  const res = await fetch(`${API_BASE}/sessions.delete.php?id=${id}`, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    credentials: "include", // 🔥 NECESARIO para enviar la cookie de login
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok || data.ok === false) {
    throw new Error(data.error || "Error al eliminar sesión");
  }

  return data;
}

// api.js (o donde tengas esta función)

export async function listarPagos({
  page = 1,
  page_size = 10,
  month = "",
  date = "",
  q = "",
  all_month,
} = {}) {
  const params = new URLSearchParams();

  params.set("page", String(page));
  params.set("page_size", String(page_size));
  if (month) params.set("month", month);
  if (date) params.set("date", date);
  if (q) params.set("q", q);
  if (typeof all_month !== "undefined") {
    params.set("all_month", String(all_month));
  }

  const res = await fetch(
    `${API_BASE}/payments.list.php?${params.toString()}`,
    { credentials: "include" }
  );

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(data.error || "Error al obtener pagos");
  }

  return {
    items: data.items || [],
    total: data.total ?? 0,
  };
}


export async function eliminarPago(id) {
  const res = await fetch(`${API_BASE}/payments.delete.php`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(data.error || "Error al eliminar pago");
  }
  return data;
}

export async function actualizarPago(payload) {
  // payload: { id, date, amount, payment_method, status, notes, enviado }
  const res = await fetch(`${API_BASE}/payments.update.php`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(data.error || "Error al actualizar pago");
  }
  return data;
}


export async function listarUsuarios({
  page = 1,
  page_size = 20,
  q = "",
  role = "",
} = {}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("page_size", String(page_size));
  if (q) params.set("q", q);
  if (role) params.set("role", role);

  const res = await fetch(`${API_BASE}/users.list.php?${params.toString()}`, {
    credentials: "include",
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(data.error || "Error al obtener usuarios");
  }

  return {
    items: data.items || [],
    total: data.total ?? 0,
  };
}

export async function eliminarUsuario(id) {
  const res = await fetch(`${API_BASE}/users.delete.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ id }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.ok) {
    throw new Error(data.error || "Error al eliminar usuario");
  }

  return true;
}


export async function crearUsuario({
  nombre,
  email,
  password,
  role,
  dni,
  colegiado,
  porcentaje_profesional,
  specialty_id, // 👈 MUY IMPORTANTE
}) {
  const res = await fetch(`${API_BASE}/users.create.php`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include", // 🔥 necesario para sesión admin
    body: JSON.stringify({
      nombre,
      email,
      password,
      role,
      dni,
      colegiado,
      porcentaje_profesional,
      specialty_id: specialty_id ?? null, // 👈 se envía solo si existe
    }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok || !data.ok) {
    console.error("❌ Error crearUsuario:", data);
    throw new Error(data.error || "Error al crear usuario");
  }

  return data.user;
}


// Obtener un usuario por ID
export async function getUsuario(id) {
  const res = await fetch(`${API_BASE}/users.get.php?id=${id}`);

  const text = await res.text(); // 👈 leemos SIEMPRE como texto primero

  if (!res.ok) {
    // error HTTP (404, 500, etc)
    console.error("user.get.php error HTTP", res.status, text);
    throw new Error(`Error HTTP ${res.status}: ${text.slice(0, 200)}`);
  }

  let data;
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.error("user.get.php no devolvió JSON válido:", text);
    throw new Error(
      "Respuesta no válida del servidor (no es JSON). Detalle: " +
        text.slice(0, 200)
    );
  }

  if (!data.ok) {
    throw new Error(data.error || "No se pudo obtener el usuario");
  }

  return data.user;
}

// Actualizar usuario
export async function updateUsuario(payload) {
  const res = await fetch(`${API_BASE}/users.update.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const text = await res.text();

  if (!res.ok) {
    console.error("user.update.php error HTTP", res.status, text);
    throw new Error(`Error HTTP ${res.status}: ${text.slice(0, 200)}`);
  }

  let data;
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.error("user.update.php no devolvió JSON válido:", text);
    throw new Error(
      "Respuesta no válida del servidor al guardar. Detalle: " +
        text.slice(0, 200)
    );
  }

  if (!data.ok) {
    throw new Error(data.error || "No se pudo actualizar el usuario");
  }

  return data;
}



export async function listarPagosPaciente(patient_id, filtros = {}) {
  const params = new URLSearchParams();

  params.set("patient_id", String(patient_id));

  // ✅ histórico completo por defecto
  if (typeof filtros.all_time === "undefined") {
    params.set("all_time", "1");
  } else {
    params.set("all_time", String(filtros.all_time));
  }

  // filtros opcionales
  Object.entries(filtros || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (k === "all_time") return;
    params.set(k, String(v));
  });

  const url = `${API_BASE}/payments.list.php?${params.toString()}`;
  console.log("[listarPagosPaciente] URL:", url);

  const res = await fetch(url, { credentials: "include" });

  const text = await res.text();
  console.log("[listarPagosPaciente] HTTP:", res.status, res.statusText, "RAW:", text.slice(0, 300));

  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch (e) {
    throw new Error("Respuesta no válida del servidor (no es JSON)");
  }

  if (!res.ok || data.ok === false) {
    throw new Error(data.error || "Error al listar pagos");
  }

  console.log("[listarPagosPaciente] Parsed:", data);
  return data.items || [];
}



export async function registrarPago(data) {
  const res = await fetch(`${API_BASE}/payments.add.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include", // 🔥 MUY IMPORTANTE: envía la cookie de sesión PHP
    body: JSON.stringify(data),
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.ok)
    throw new Error(json.error || "Error al registrar pago");
  return json;
}


export async function listarSesionesPendientesPago() {
  const res = await fetch(`${API_BASE}/payments.pending_sessions.php`, {
    credentials: "include", // 🔥 IMPORTANTE: envía sesión PHP
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false)
    throw new Error(data.error || "Error al cargar sesiones pendientes");

  return data;
}

// 🔹 Listar gastos de un mes
export async function listarGastosMes(mes) {
  const params = new URLSearchParams({ mes });
  const res = await fetch(`${API_BASE}/gastos.mes.php?${params.toString()}`, {
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) {
    throw new Error(data.error || "Error al listar gastos del mes");
  }
  return data; // { mes, items, total }
}

// 🔹 Crear un gasto nuevo para un mes
export async function crearGastoMes({ mes, concepto, importe }) {
  const res = await fetch(`${API_BASE}/gastos.mes.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ mes, concepto, importe }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) {
    throw new Error(data.error || "Error al crear gasto");
  }
  return data; // { ok, id }
}


export async function obtenerPagoPorId(id) {
  const res = await fetch(`${API_BASE}/payments.get.php?id=${id}`, {
    credentials: "include",
  });
  const data = await res.json().catch(() => ({}));
  console.log("📦 Respuesta payments.get:", data);
  if (!res.ok || !data.ok) throw new Error(data.error || "Error al cargar pago");
  return data;
}

// 📌 Estadísticas de clientes (creados + con sesiones + control)
export async function statsClientes(mes, params = {}) {
  const qs = new URLSearchParams({
    mes,
    umbral_dias: params.umbral_dias ?? 45,
    nuevo_dias: params.nuevo_dias ?? 14,
  }).toString();

  const res = await fetch(`${API_BASE}/stats.clientes.php?${qs}`, {
    credentials: "include",
  });

  const data = await res.json();

  if (!res.ok || !data.ok) {
    throw new Error(data.error || "Error al cargar estadísticas de clientes");
  }

  return data;
}



export async function enviarFacturaPorEmail(id) {
  try {
    const res = await fetch(`${API_BASE}/payments.send_email.php?id=${id}`);

    const data = await res.json();

    if (!res.ok || !data.ok) {
      throw new Error(data.error || "Error al enviar el correo");
    }

    return data; // ← Devuelve el mensaje y el estado 'enviado'
  } catch (err) {
    console.error("Error en enviarFacturaPorEmail:", err);
    throw err;
  }
}

export async function guardarComentarioSesion(id, comentario) {
  const res = await fetch(`${API_BASE}/session.coment.save.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include", // 🔥 Esto envía las cookies (sesión activa)
    body: JSON.stringify({ id, comentario }),
  });

  if (!res.ok) throw new Error("Error al guardar comentario");
  return await res.json();
}

// ---------- Specialties (Especialidades) ----------
// ---------- Specialties (Especialidades) ----------
export async function listarEspecialidades() {
  const res = await fetch(`${API_BASE}/specialties.list.php`, { credentials: "include" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) throw new Error(data.error || "Error al listar especialidades");
  return data; // 👈 {ok:true, items:[...]}
}



export async function crearEspecialidad({ nombre }) {
  const res = await fetch(`${API_BASE}/specialties.create.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ nombre }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.ok === false) {
    throw new Error(data.error || "Error al crear especialidad");
  }

  // esperamos { ok:true, specialty:{id, code, nombre} }
  return data.specialty;
}


export async function descargarFacturasZip({ month, paymentIds = [] } = {}) {
  const res = await fetch(`${API_BASE}/invoices.zip.php`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ month, paymentIds }),
  });

  const contentType = res.headers.get("content-type") || "";

  // Si status no OK, intenta leer texto útil (PHP/HTML/JSON)
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(
      `HTTP ${res.status}. Content-Type: ${contentType}. ` +
        (text ? `Respuesta: ${text.slice(0, 500)}` : "Sin cuerpo")
    );
  }

  // Lee blob siempre
  const blob = await res.blob();

  // ✅ Validación ZIP real por firma "PK" (0x50 0x4B)
  const headBuf = await blob.slice(0, 2).arrayBuffer();
  const sig = new Uint8Array(headBuf);
  const isZip = sig.length === 2 && sig[0] === 0x50 && sig[1] === 0x4b;

  if (!isZip) {
    // A veces viene HTML/JSON con status 200 -> lo mostramos
    const text = await blob.text().catch(() => "");
    throw new Error(
      `El servidor NO devolvió un ZIP válido.\n` +
        `Content-Type: ${contentType}\n` +
        `Respuesta: ${text.slice(0, 800)}`
    );
  }

  const filename = `${month}_facturas.zip`;

  // Descargar
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);

  return true;
}


export async function pagosComparativa(year) {
  const res = await fetch(`${API_BASE}/balance.comparativa.php?year=${encodeURIComponent(year)}`, {
    credentials: "include",
  });

  const text = await res.text(); // <-- para capturar HTML/errores también
  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    console.error("[pagosComparativa] NO JSON:", text.slice(0, 800));
    throw new Error("El servidor no devolvió JSON (mira consola).");
  }

  if (!res.ok || data.ok === false) {
    console.error("[pagosComparativa] ERROR:", data);
    throw new Error(data.error || `HTTP ${res.status}`);
  }

  return data.items || [];
}
